import styled from 'styled-components';
import theme from '../../theme';

const StyledAnnualFinancials = styled.section`
  .collapse-grill{
    .ant-collapse-item{
      border: none;
      .ant-collapse-header{
        color: ${theme.corellBlue};
      }
    }
  }
  .image-grayscale{
    filter: grayscale(100%);
  }
  .anchor-link-single{
    color: ${theme.corellBlue};
    font-weight: 600;
    font-size: 16px;
    border: none;
    display: block;
    background: transparent;
    margin: 16px 0px 16px 16px;
  }
`;

export { StyledAnnualFinancials };



// WEBPACK FOOTER //
// client/containers/StaticPages/StyledStaticPages.js